import { Content } from "@iventis/translations/content/typed-content";
import { Header4 } from "@iventis/styles/src/components/texts";
import { popoverPadding, styled } from "@iventis/styles";
import { fontSizes } from "@iventis/styles/src/atomic-rules";
import { SearchResultGroupInterface } from "@iventis/search/interface/search-result-interface";
import { useSearch } from "@iventis/search/hooks/use-search";
import { SearchState, MapSearchResultType } from "@iventis/search/types/types";
import { SearchResults } from "@iventis/search/components/search-results";
import { CloseButton } from "@iventis/components";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import debounce from "lodash.debounce";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { SearchBarComponent } from "@iventis/search/components/search-bar";
import { SidebarState } from "./state/sidebar.slice.types";
import { sidebar } from "./state/sidebar.slice";
import MapViewsList from "./map-views-list";

export const SearchComponent = ({ searchResultGroups }: { searchResultGroups?: SearchResultGroupInterface<MapSearchResultType>[] }) => {
    const dispatch = useDispatch();

    const { fullScreenSelector } = useSelector(({ sidebarReducer }: { sidebarReducer: SidebarState }) => sidebarReducer);
    const translate = useIventisTranslate();

    const [searchValue, setSearchValue] = useState("");
    const [handleSearch, searchResults, state, searchedString] = useSearch(searchResultGroups);
    const updateSearch = React.useRef(debounce(handleSearch, 400));

    const handleSearchValueChange = (value: string) => {
        setSearchValue(value);
        updateSearch.current(value);
    };

    const handleClose = () => {
        if (fullScreenSelector) {
            dispatch(sidebar.actions.setFullScreenSelector(null));
        } else {
            dispatch(sidebar.actions.closePopover());
        }
    };

    return (
        <StyledSearch fullscreen={fullScreenSelector != null}>
            <CloseButton dataTestId="close-map-search" onMouseDown={handleClose} />
            <Header4>{translate(Content.map.search.search_map)}</Header4>
            <SearchBarComponent
                placeHolderText={translate(Content.map.search.search_description)}
                value={searchValue}
                onValueChange={handleSearchValueChange}
                fontSize="small"
                debounceMs={400}
                className="search-bar"
                loading={state === SearchState.SEARCHING}
                autoFocus
                testid="map-search-bar"
            />
            {state === SearchState.IDLE ? (
                <MapViewsList />
            ) : (
                <SearchResults
                    searching={state === SearchState.SEARCHING}
                    resultGroups={searchResults}
                    noResultsMessage={translate(Content.map.search.no_results)}
                    searchString={searchedString}
                />
            )}
        </StyledSearch>
    );
};

const StyledSearch = styled.div<{ fullscreen: boolean }>`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: ${popoverPadding.standard};
    padding: ${popoverPadding.standard};
    padding-bottom: 5px;
    width: ${(props) => (props.fullscreen ? "100%" : "330px")};
    height: ${(props) => (props.fullscreen ? "100%" : "500px")};
    overflow: hidden;
    .search-bar {
        width: 100%;
        font-size: ${fontSizes.small};
    }
`;
